export const HOME_LIST_LIMIT = 30
export const HOME_MAX_LIMIT = 50
